const URLS = {
    community: '/community',
    events: '/events',
    features: '/features',
    marketplace: '/marketplace',
    cases: '/cases',
    blog: '/blog',
    docs: '/docs',
};

const DEFAULT_FEATURES_FILTER = {
    page: 1,
    rowsPerPage: 10,
    orderBy: 'votes',
    status: 'active',
};

const PREVIEW_FEATURES_FILTER = {
    rowsPerPage: 3,
};

const FeatureStatus = {
    Filed: 'filed',
    Verified: 'verified',
    Planned: 'planned',
    Preview: 'preview',
    Completed: 'completed',
    Rejected: 'rejected',
    Duplicated: 'duplicated',
    Declined: 'declined',
};

const BlogFilters = {
    Date: 'date',
    Popularity: 'likes',
};

const VotableFeatureStatuses = [
    FeatureStatus.Verified,
    FeatureStatus.Planned,
    FeatureStatus.Preview,
];

const MAIN_PAGE_EVENTS_COUNT = 3;

module.exports = {
    URLS,
    DEFAULT_FEATURES_FILTER,
    PREVIEW_FEATURES_FILTER,
    FeatureStatus,
    VotableFeatureStatuses,
    MAIN_PAGE_EVENTS_COUNT,
    BlogFilters,
};
